import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=30adf8b8&scoped=true"
import script from "./Changepassword.vue?vue&type=script&lang=js"
export * from "./Changepassword.vue?vue&type=script&lang=js"
import style0 from "./Changepassword.vue?vue&type=style&index=0&id=30adf8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30adf8b8",
  null
  
)

export default component.exports